import { Solucion } from '@/shared/model/seguimiento/solucion.model';
import { EventoNomina } from '@/shared/model/seguimiento/financiero/evento-nomina.model';
import { EstadoNomina } from '@/shared/model/enumerations/estado-nomina';
import { ArchivoConciliacion } from './archivo-conciliacion.model';
import { TipoSolucion } from '@/shared/model/enumerations/tipo-solucion.model';
import { CambioMoneda } from '@/shared/model/seguimiento/financiero/cambio-moneda.model';
import { CatalogoGenerico } from '@/shared/model/seguimiento/catalogo-generico.model';
import { Pago } from '@/shared/model/seguimiento/financiero/pago.model';
import { TipoNomina } from '@/shared/model/enumerations/tipo-nomina.model';
import { ConceptoNominaNacionales } from '../../enumerations/concepto-nomina-nacionales.model';

export interface INomina {
  id?: string | null;
  clave?: string | null;
  mes?: number | null;
  anio?: number | null;
  nombre?: string | null;
  tipoNomina?: TipoNomina | null;
  descripcion?: string | null;
  estadoActual?: EstadoNomina | null;
  solucion?: Solucion | null;
  eventoNomina?: EventoNomina[] | null;
  archivosConciliacion?: ArchivoConciliacion[] | null;
  fechaCorte?: string | null;
  tipoSolucion?: TipoSolucion | null;
  cambiosMoneda?: CambioMoneda[] | null;
  conceptoPago?: CatalogoGenerico | null;
  pagos?: Pago[] | null;
  isDivisa?: boolean | null;
  isInstitucion?: boolean | null;
  isRecuperacion?: boolean | null;
  conceptoNomina?: ConceptoNominaNacionales | null;
  isCurso?: boolean | null;
  isApoyoUnico?: boolean | null;
}

export class Nomina implements INomina {
  constructor(
    public id?: string | null,
    public clave?: string | null,
    public mes?: number | null,
    public anio?: number | null,
    public nombre?: string | null,
    public tipoNomina?: TipoNomina | null,
    public descripcion?: string | null,
    public estadoActual?: EstadoNomina | null,
    public solucion?: Solucion | null,
    public eventoNomina?: EventoNomina[] | null,
    public archivosConciliacion?: ArchivoConciliacion[] | null,
    public fechaCorte?: string | null,
    public tipoSolucion?: TipoSolucion | null,
    public cambiosMoneda?: CambioMoneda[] | null,
    public conceptoPago?: CatalogoGenerico | null,
    public pagos?: Pago[] | null,
    public isDivisa?: boolean | null,
    public isInstitucion?: boolean | null,
    public isRecuperacion?: boolean | null,
    public conceptoNomina?: ConceptoNominaNacionales | null,
    public isCurso?: boolean | null,
    public isApoyoUnico?: boolean | null
  ) {
    this.solucion = this.solucion ? this.solucion : new Solucion();
    this.archivosConciliacion = this.archivosConciliacion ? this.archivosConciliacion : [];
    this.conceptoPago = this.conceptoPago ? this.conceptoPago : new CatalogoGenerico();
    this.pagos = this.pagos ? this.pagos : [];
  }

  static fromObject(data: INomina): Nomina {
    const nomina = new Nomina();
    for (const [key, value] of Object.entries(data)) {
      nomina[key] = value;
    }
    return nomina;
  }
}
